import React, { useEffect, useState } from "react";
import styles from "./ReviewsAndBlogs.module.css";
import BlogPost from "./BlogPost";
import RecentPosts from "./recent-posts/RecentPosts";
import { API_BASE_URL } from "configs/AppConfig";
import Loader from "../common-component/Loader/Loader";
import MetaDetails from "components/meta-details/MetaDetails";
import SEO from "components/SEO/SEO";


function ReviewsAndBlogs() {
  const [list, setList] = useState([]);
  const [data, setData] = useState();

  const fetchData = async () => {
    const response = await fetch(
      `${API_BASE_URL}pages/get/all?category=6708c38c5e9b4984e1e2212e`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    setList(data?.data?.sort((a, b) => a.priority - b.priority));
    console.log("data pages", data);

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <SEO />

      <MetaDetails
        title={"Reviews & Blogs"}
        description={"Reviews and Blogs"}
        keywords={["reviews", "blogs"]?.join(", ")}
      />
      {list?.length == 0 ? (
        <Loader />
      ) : (
        <div className={styles.reviewsOuter}>
          <div className={styles.titleSection}>
            <div data-aos="fade-right" data-aos-delay="200">
              <h1>{`REVIEWS & BLOGS `}</h1>
              <h2>- BODYSHOPGURU</h2>
            </div>
            <p data-aos="fade-right" data-aos-delay="200">
              Expert insights and honest reviews to keep your car body shop
              ahead of the curve.
            </p>
            <img
              data-aos="fade-down"
              data-aos-delay="200"
              src="/img/bodyshop/down-arrow.svg"
            />
          </div>
          <img
            src="/img/bodyshop/down-arrow.svg"
            className={styles.onlyMobile}
          />
          <div className={styles.flexSection}>
            <main className={styles.blogPostList}>
              {list.map((post, index) => (
                <BlogPost key={index} {...post} />
              ))}
            </main>
            <div className={styles.recentPostDiv}>
              <RecentPosts list={list} background="#0096FF" textColor="#FFF" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ReviewsAndBlogs;
